import { getOverflowParentDimensions, getOverflowParents } from '../../utils/scrollable-containers';
var AVAILABLE_SPACE_RESERVE = 50;
var getClosestParentDimensions = function (element) {
    var parents = getOverflowParents(element).map(function (el) {
        var _a = el.getBoundingClientRect(), height = _a.height, width = _a.width, top = _a.top, left = _a.left;
        return {
            height: height,
            width: width,
            top: top,
            left: left
        };
    });
    return parents.shift();
};
export var getAvailableSpace = function (trigger, dropdown, expandToViewport) {
    var overflowParents = getOverflowParentDimensions(dropdown, false, expandToViewport);
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerLeft = _a.left, triggerRight = _a.right;
    return overflowParents.reduce(function (_a, overflowParent) {
        var above = _a.above, below = _a.below, left = _a.left, right = _a.right;
        var offsetTop = triggerBottom - overflowParent.top;
        var currentAbove = offsetTop - trigger.offsetHeight - AVAILABLE_SPACE_RESERVE;
        var currentBelow = overflowParent.height - offsetTop - AVAILABLE_SPACE_RESERVE;
        var currentLeft = triggerRight - overflowParent.left - AVAILABLE_SPACE_RESERVE;
        var currentRight = overflowParent.left + overflowParent.width - triggerLeft - AVAILABLE_SPACE_RESERVE;
        return {
            above: Math.min(above, currentAbove),
            below: Math.min(below, currentBelow),
            left: Math.min(left, currentLeft),
            right: Math.min(right, currentRight)
        };
    }, { above: Number.MAX_VALUE, below: Number.MAX_VALUE, left: Number.MAX_VALUE, right: Number.MAX_VALUE });
};
export var getInteriorAvailableSpace = function (trigger, dropdown, expandToViewport) {
    var overflowParents = getOverflowParentDimensions(dropdown, true, expandToViewport);
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerTop = _a.top, triggerLeft = _a.left, triggerRight = _a.right;
    return overflowParents.reduce(function (_a, overflowParent) {
        var above = _a.above, below = _a.below, left = _a.left, right = _a.right;
        var currentAbove = triggerBottom - overflowParent.top - AVAILABLE_SPACE_RESERVE;
        var currentBelow = overflowParent.height - triggerTop + overflowParent.top - AVAILABLE_SPACE_RESERVE;
        var currentLeft = triggerLeft - overflowParent.left - AVAILABLE_SPACE_RESERVE;
        var currentRight = overflowParent.left + overflowParent.width - triggerRight - AVAILABLE_SPACE_RESERVE;
        return {
            above: Math.min(above, currentAbove),
            below: Math.min(below, currentBelow),
            left: Math.min(left, currentLeft),
            right: Math.min(right, currentRight)
        };
    }, { above: Number.MAX_VALUE, below: Number.MAX_VALUE, left: Number.MAX_VALUE, right: Number.MAX_VALUE });
};
export var getDropdownPosition = function (trigger, dropdown, expandToViewport, minWidth, preferCenter) {
    if (expandToViewport === void 0) { expandToViewport = false; }
    if (preferCenter === void 0) { preferCenter = false; }
    var availableSpace = getAvailableSpace(trigger, dropdown, expandToViewport);
    var triggerWidth = trigger.getBoundingClientRect().width;
    minWidth = minWidth ? Math.min(triggerWidth, minWidth) : triggerWidth;
    var requiredWidth = dropdown.getBoundingClientRect().width;
    // dropdown should not be smaller than the trigger
    var idealWidth = Math.max(requiredWidth, minWidth);
    var _a = trigger.getBoundingClientRect(), triggerRight = _a.right, triggerBottom = _a.bottom, triggerLeft = _a.left, triggerTop = _a.top;
    var dropLeft;
    var left = null;
    var width = idealWidth;
    //1. Can it be positioned with ideal width to the right?
    if (idealWidth <= availableSpace.right) {
        dropLeft = false;
        //2. Can it be positioned with ideal width to the left?
    }
    else if (idealWidth <= availableSpace.left) {
        dropLeft = true;
        //3. Fit into biggest available space either on left or right
    }
    else {
        dropLeft = availableSpace.left > availableSpace.right;
        width = Math.max(availableSpace.left, availableSpace.right, minWidth);
    }
    if (preferCenter) {
        var spillOver = (idealWidth - triggerWidth) / 2;
        // availableSpace always includes the trigger width, but we want to exclude that
        var availableOutsideLeft = availableSpace.left - triggerWidth;
        var availableOutsideRight = availableSpace.right - triggerWidth;
        var fitsInCenter = availableOutsideLeft >= spillOver && availableOutsideRight >= spillOver;
        if (fitsInCenter) {
            left = -spillOver;
        }
    }
    var dropUp = availableSpace.below < dropdown.offsetHeight && availableSpace.above > availableSpace.below;
    var availableHeight = dropUp ? availableSpace.above : availableSpace.below;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    var croppedHeight = Math.floor(availableHeight / 31) * 31 + 16;
    return {
        dropUp: dropUp,
        dropLeft: dropLeft,
        left: left === null ? 'auto' : left + "px",
        height: croppedHeight + "px",
        width: width + "px",
        triggerRight: triggerRight + "px",
        triggerBottom: triggerBottom + "px",
        triggerLeft: triggerLeft + "px",
        triggerTop: triggerTop + "px"
    };
};
export var getInteriorDropdownPosition = function (trigger, dropdown, expandToViewport) {
    var availableSpace = getInteriorAvailableSpace(trigger, dropdown, expandToViewport);
    var _a = trigger.getBoundingClientRect(), triggerRight = _a.right, triggerBottom = _a.bottom, triggerTop = _a.top, triggerLeft = _a.left, triggerWidth = _a.width;
    var _b = getClosestParentDimensions(trigger), parentDropdownTop = _b.top, parentDropdownHeight = _b.height;
    var dropLeft;
    var width = dropdown.getBoundingClientRect().width;
    var top = triggerTop - parentDropdownTop;
    if (width <= availableSpace.right) {
        dropLeft = false;
    }
    else if (width <= availableSpace.left) {
        dropLeft = true;
    }
    else {
        dropLeft = availableSpace.left > availableSpace.right;
        width = Math.max(availableSpace.left, availableSpace.right);
    }
    var left = dropLeft ? 0 - width : triggerWidth;
    var dropUp = availableSpace.below < dropdown.offsetHeight && availableSpace.above > availableSpace.below;
    var bottom = dropUp ? parentDropdownTop + parentDropdownHeight - triggerBottom : 0;
    var availableHeight = dropUp ? availableSpace.above : availableSpace.below;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    var croppedHeight = Math.floor(availableHeight / 31) * 31 + 16;
    return {
        dropUp: dropUp,
        dropLeft: dropLeft,
        height: croppedHeight + "px",
        triggerRight: triggerRight + "px",
        triggerBottom: triggerBottom + "px",
        triggerLeft: triggerLeft + "px",
        width: width + "px",
        top: top + "px",
        bottom: bottom + "px",
        left: left + "px"
    };
};
//# sourceMappingURL=dropdown-fit-handler.js.map